import React, { useState } from 'react';
import { FormControl, InputLabel, NativeSelect } from '@material-ui/core';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { translations } from '../../locales/translations';

export const Dropdown = (props) => {
  const { label, valueList, defaultValue, readOnly, onSelectedValue } = props;
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  React.useEffect(() => {
    if (onSelectedValue) {
      onSelectedValue(selectedValue);
    }
  }, [selectedValue]);

  function onChange(event) {
    setSelectedValue(event.target.value);
  }

  return (
    <Wrapper>
      <InputLabel className='input-label'>
        {t(label)}
      </InputLabel>
      <FormControl>
        <NativeSelect value={selectedValue} onChange={onChange} disabled={readOnly}>
          {valueList.map((item, index) =>
            <option value={item} key={item}>{t(translations.biType[item])}</option>,
          )}
        </NativeSelect>
      </FormControl>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-left: 20px;
`;
